import 'isomorphic-fetch';
import baseFetch from './baseFetch';
import config from '../config';

export const getSpotMapData = async ({ north, south, east, west }) => {
  // TODO: Move this to config
  const url = `/kbyg/mapview?south=${south}&west=${west}&north=${north}&east=${east}`;
  return baseFetch(url);
};

export const getUserRegion = async () => {
  // TODO: Move this to config
  const url = `${config.servicesURL}/geo-target/region`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status > 200) throw body;
  return body;
};

export const getNearestSpot = async ({ lat, lon }) => {
  // TODO: Move this to config
  const url = `${config.productAPI}/kbyg/mapview/spot?lat=${lat}&lon=${lon}`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status > 200) throw body;
  return body;
};

export const fetchLocationMapView = async geonameId => {
  const url = `${config.productAPI}/location/view?type=mapView&id=${geonameId}`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status === 400) throw response;
  if (response.status > 200) throw body;
  return body;
};
